import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"

import DatePickerInput from "./DatePickerInput"

const FirstDayInput = () => {
  const {
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext()
  const lastDay = watch("lastDay")

  const handleFirstDayChange = (dateSelection) => {
    setValue("first_day", dateSelection)
    trigger("first_day")
  }

  return (
    <div>
      <Form.Label htmlFor="stw-first-day">First Day</Form.Label>
      <Controller
        name="first_day"
        render={({ field: { value } }) => (
          <Form.DatePicker
            id="stw-first-day"
            maxDate={lastDay}
            hasErrors={Boolean(errors?.first_day)}
            renderCustomHeader={(props) => (
              <Form.DatePicker.QuickNavHeader {...props} />
            )}
            value={value}
            onChange={handleFirstDayChange}
            customInput={
              <DatePickerInput
                errorMessage={
                  errors?.first_day ? errors.first_day.message : null
                }
              />
            }
          />
        )}
      />
    </div>
  )
}

export default FirstDayInput
